var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function Chat2IconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.5081 21.6661 14.9383 21.0683 16.2206L21.9456 20.4204C22.1717 21.5028 21.4818 22.1948 20.4008 21.9652L16.2068 21.0747C14.928 21.6685 13.5027 22 12 22ZM15.9696 18.9798L19.7713 19.7926L18.9746 15.9784L19.2556 15.3755C19.7438 14.3285 20 13.1844 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.1802 20 14.3204 19.7456 15.3645 19.2608L15.9696 18.9798Z", fill: "" })));
}
export var Chat2Icon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: Chat2IconInner }, props))); };
//# sourceMappingURL=Chat2Icon.js.map